import '../../style/index.less';
import './index.less';



// WEBPACK FOOTER //
// ./components/carousel/style/index.tsx